import {data} from './data';
import {ExplainSection, Explanations} from './types';

export const useExplanation = (
  whichExplanation: Explanations,
): ExplainSection => {
  return data[whichExplanation] || {};
};
